import { useEffect, useState } from "react";

/**
 * Phase 43.43 — Detecta se la tastiera virtuale è aperta su iOS Safari / PWA.
 *
 * `window.visualViewport` riporta l'area effettivamente visibile (esclusa la
 * tastiera). Se l'altezza è significativamente minore di `window.innerHeight`
 * (default soglia 150px), consideriamo la tastiera aperta.
 *
 * Usato per nascondere la bottom nav quando la tastiera è aperta, evitando
 * l'effetto "nav sollevata di 1cm" tipico di iOS PWA quando un input prende
 * focus e il visual viewport si restringe.
 */
export function useIsKeyboardOpen(threshold = 150) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const vv = window.visualViewport;
    if (!vv) return;

    const onChange = () => {
      const heightDelta = window.innerHeight - vv.height;
      setOpen(heightDelta > threshold);
    };
    onChange();
    vv.addEventListener("resize", onChange);
    vv.addEventListener("scroll", onChange);
    return () => {
      vv.removeEventListener("resize", onChange);
      vv.removeEventListener("scroll", onChange);
    };
  }, [threshold]);

  return open;
}
